import React from "react";
import * as ReactBootstrap from "react-bootstrap";
import Title from "./../ReusableComponents/title";
import { dollarUS } from "../../utilities/formatters";

const StatFormatter = (data) => {
  const classList = data < 0 ? "Negative" : "Positive";
  return <div className={`Status ${classList}`}>{dollarUS(data)}</div>;
};

const InstrumentsTable = ({ data }) => {
  const renderInstruments = (instrument, index) => {
    const data = instrument[1];
    return (
      <tr key={index}>
        <td>{instrument[0]}</td>
        <td>{data.number_of_trade}</td>
        <td>{StatFormatter(Number(data.results).toFixed(2))}</td>
      </tr>
    );
  };

  return (
    <div className="CommonTable InstrumentsTable">
      <Title six>Results by Instruments</Title>
      <ReactBootstrap.Table>
        <thead>
          <tr>
            <th>Instruments</th>
            <th>No. trades</th>
            <th>Results</th>
          </tr>
        </thead>
        <tbody>{data && data.map(renderInstruments)}</tbody>
      </ReactBootstrap.Table>
    </div>
  );
};

export default InstrumentsTable;
